import type { BoxProps } from '@withjoy/joykit';
import { styled, Box } from '@withjoy/joykit';

export const StyledBox = styled(Box)<{ maxWidth: BoxProps['marginBottom'] }>`
  max-width: ${({ maxWidth }) => maxWidth};
`;
